<button
  mat-icon-button
  [color]="hasFilters() ? 'primary' : ''"
  [matMenuTriggerFor]="aftaleFilter"
  matTooltip="Brug filtre"
  [matBadge]="filterCount()"
  matBadgeSize="small"
  [matBadgeHidden]="filterCount() === 0"
  [disabled]="isLoading"
  >
  <mat-icon svgIcon="filter"></mat-icon>
</button>
<mat-menu #aftaleFilter="matMenu">
  @if (hasFilters()) {
    <button (click)="reset()" title="Fjern alle filtre" class="btn-icon red">
      <mat-icon svgIcon="delete"></mat-icon>
      <span>Fjern alle filtre</span>
    </button>
    <hr />
  }
  @for (produkt of produkter; track produkt) {
    <div (click)="$event.stopPropagation()">
      <mat-slide-toggle [checked]="isProductChecked(produkt.id)" color="primary" (change)="onProductToggle(produkt.id)">
        <mat-icon [svgIcon]="produkt.text.toLowerCase()" [matTooltip]="produkt.text | titlecase"></mat-icon>
        <span>{{ produkt.text }}</span>
      </mat-slide-toggle>
    </div>
  }
  <hr />

  <div (click)="$event.stopPropagation()">
    <app-fabrikat-filter [fabrikater]="fabrikater" [filter]="filter" (fabrikatChange)="onFabrikatChange($event)"></app-fabrikat-filter>
  </div>

  <!-- <div class="margin--left-m margin--right-m">
  <mat-form-field appearance="outline">
    <mat-label>Fabrikat</mat-label>
    <mat-select (selectionChange)="onFabrikatChange($event)">
      <mat-option *ngFor="let fabrikat of fabrikater" [value]="fabrikat.id">{{ fabrikat.name }} - {{ fabrikat.produkt.text }}</mat-option>
    </mat-select>
  </mat-form-field>
</div> -->
</mat-menu>
